<div class="flex flex-col gap-4">
  @if (settings(); as recall) {
    <div>
      <div class="font-bold">Recall Period</div>
      {{ recall.periodInMonths }}
      {{ recall.periodInMonths === 1 ? 'month' : 'months' }}
    </div>
  }
  <div>
    <div class="font-bold">Recall Treatments</div>
    @for (treatment of treatments(); track treatment.ref.path) {
      <div>{{ treatment.name }}</div>
    } @empty {
      <div class="text-xs opacity-50">None</div>
    }
  </div>
  @if (showOverlapChip()) {
    <span
      class="inline-flex w-fit items-center rounded-full bg-amber-100 px-3 py-1 text-xs font-medium text-amber-800"
      [matTooltip]="overlapTooltip()"
    >
      Overlaps with {{ otherTrackLabel() }}
    </span>
  }
</div>
